import { Link } from 'react-router'
import { LinkProps, Link as MuiLink, Stack, SvgIcon } from '@mui/material'
import { IconExternalLink } from '@tabler/icons-react'

export const TextLink = ({ to, label, ...props }: { to: string; label: string } & LinkProps) => {
  const isExternal = props.target === '_blank'
  return (
    <Stack direction="row" spacing={1} useFlexGap sx={{ alignItems: 'center' }}>
      <MuiLink
        component={Link}
        to={to}
        underline="hover"
        {...props}
        rel={isExternal ? 'noreferrer noopener' : undefined}
      >
        {label}
      </MuiLink>
      {isExternal ? (
        <SvgIcon fontSize="small">
          <IconExternalLink stroke={1.5} />
        </SvgIcon>
      ) : null}
    </Stack>
  )
}
